import React, {useEffect, useState} from 'react';
import {fetchJson} from '../../utils/util_functions';
import Column from '../nav/Column';
import Link from '../nav/Link';
import './style.scss';

const NavFooter = (props) => {

  const [menuData, setMenuData] = useState([]);
  const [companyMenuData, setCompanyMenuData] = useState([]);
  const [socialMenuData, setSocialMenuData] = useState([]);
  const [legalMenuData, setLegalMenuData] = useState([]);

  /// Fetch menu JSON from endpoints
  useEffect(() => {

    let path = process.env.CMS_API + 'footer-menu-unified' + (process.env.NODE_ENV == "local" ? ".json" : "?_format=json");

    fetchJson(path).then((json) => {
      setMenuData(json);
    });

    path = process.env.CMS_API + 'footer-autodesk' + (process.env.NODE_ENV == "local" ? ".json" : "?_format=json");
    fetchJson(path).then((json) => {
      setCompanyMenuData(json);
    });

    path = process.env.CMS_API + 'follow-us' + (process.env.NODE_ENV == "local" ? ".json" : "?_format=json");
    fetchJson(path).then((json) => {
      setSocialMenuData(json);
    });

    path = process.env.CMS_API + 'footer' + (process.env.NODE_ENV == "local" ? ".json" : "?_format=json");
    fetchJson(path).then((json) => {
      setLegalMenuData(json);
    });
  }, []);

  return (
    <div className={`aps__nav-footer`}>
      <div className={`constrain`}>
        <div className={`aps__footer-left`}>
          <a 
            data-test-id="footer-logo-link"
            data-external-target="footer-logo-link"
            key={`logo`}
            className={`adsk__logo`}
            href="https://www.autodesk.com/"
            title="Autodesk"
            aria-label="Autodesk"
          >
            <img
              src="//aps.autodesk.com/static/1.0.0.20251007161555/images/adsk-logo--black.svg"
              alt="Autodesk"
            />
          </a>
          <Column key={`company`}
                  links={companyMenuData}
                  classes={`aps__footer-company`}></Column>
          <Column key={`social`}
                  links={socialMenuData}
                  classes={`aps__footer-social`}>
            <label>Follow APS</label>
          </Column>
        </div>
        <div className={`aps__footer-menu`}>
          {menuData.map((item) => {
            return (
              <Column key={item.key} links={item.below}>
                <label>{item.title}</label>
              </Column>
            );
          })}
        </div>
      </div>
      <div className={`aps__footer-legal`}>
        <div className={`constrain`}>
          {legalMenuData.map((item) => {
            let classes = item.options?.attributes?.class ? item.options.attributes.class.join(' ') : '';
            if (classes.indexOf('attr_data-opt-in-preferences') != -1) {
              return (
                <a key={item.key}
                   className={`aps__link ${classes}`}
                   href="javascript:;"
                   data-opt-in-preferences>{item.title}</a>
              );
            } else {
              return (
                <Link key={item.key}
                      link={item.absolute}
                      target={item.options?.attributes?.target ? item.options.attributes.target : ''}
                      classes={classes}>
                  {item.title}
                </Link>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default NavFooter;
